import { ConcreteEncodable } from "./ConcreteEncodable";

import { HeartBeatImplEncoder } from "../../encoder/HeartBeatImplEncoder";

import * as CubiqTS from "../../index";
import { HeartBeat } from "../HeartBeat";

export class HeartBeatImpl extends ConcreteEncodable implements HeartBeat {
  public static enType: string = "com.bcdfx.model.HeartBeatImpl";

  /*FID=1*/
  public serverTime: string;
  /*FID=2*/
  public serviceConnected: boolean;
  /*FID=3*/
  public serviceAggregate: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = HeartBeatImplEncoder.Instance;
    this.setEncodableType(HeartBeatImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "HeartBeatImpl[" +
      "serverTime=" +
      this.serverTime +
      "serviceConnected=" +
      this.serviceConnected +
      "serviceAggregate=" +
      this.serviceAggregate +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
